import { memo, useCallback, useEffect, useState } from "react"

import Button from "components/Button/Button"
import Input from "components/Input/Input"

import { FreeSearchProps } from "./types"

export const FreeSearch = memo(({ label, onApply, initialValue }: FreeSearchProps) => {
    const [value, setValue] = useState(initialValue || '')

    useEffect(() => {
        setValue(initialValue || '')
    }, [initialValue])

    const handleChange = useCallback((value: string) => {
        setValue(value)
    }, [])

    return (
        <div className="flex flex-col p-3 gap-4 rounded-md ">
            <div className="text-p-s font-medium text-base-foreground">
                {label}
            </div>
            <div>
                <Input
                    placeholder="Search"
                    value={value}
                    onChange={(e) => handleChange(e.target.value)}
                    className="w-full border-none shadow-none outline-none h-9 focus:ring-0 focus:border-none active:ring-0 active:border-none focus-visible:ring-0 focus-visible:border-none"
                />
            </div>
            <Button onClick={() => onApply(value)} variant="outline">
                Apply
            </Button>

        </div>
    )
})